import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PathwayMapping } from 'src/shared/models/pathway-mapping.model';
import { AuthService } from 'src/shared/services/auth.service';
import { PathwayMappingService } from 'src/shared/services/pathway-mapping.service';
import { RegistrationService } from 'src/shared/services/registration.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { SetupService } from 'src/shared/services/setup.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-approver-setup',
  templateUrl: './approver-setup.component.html',
  styleUrl: './approver-setup.component.scss'
})
export class ApproverSetupComponent {

  @ViewChild('addSetup', {static: true}) public modalAddSetup: NgbModalRef;
  @ViewChild('editSetup', {static: true}) public modalEditSetup: NgbModalRef;

  paramForm: FormGroup;
  newForm: FormGroup;
  editForm: FormGroup;
  data: any[] = [];
  detailData: any;
  columnsToDisplay = ['module_name', 'year-period', 'year_level','role', 'fullname', 'action'];
  sort = 'asc';
  orderBy = 'activity_name';
  subscription: Subscription;
  loading = false;
  searchParam: string;
  periodSelected: any;
  periodList: any;
  apiRun: Subscription;
  yearLevelRelations: any;
  yearLevelRelationsSelected: any[] = [];
  roleList: any;
  userList: any;
  moduleList = ['School Program New Activity Approval', 'School Program Activity Participant Approval'];
  moduleSelected: any;
  setupList: any[] = [];
  showEditModal = false;

  constructor(
    private setupService: SetupService,
    private spService: SchoolProgramService,
    private translate: TranslateService,
    private pmService: PathwayMappingService,
    private modalService: NgbModal,
    private registService: RegistrationService,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular', 'activity');
    this.initForm();
    this.getPeriodList();
    this.getRoleList();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'approver_setup_id': new FormControl(null),
      'module_name': new FormControl(null),
      'period_id': new FormControl(null)
    });

    this.newForm = new FormGroup({
      'academic_year': new FormControl(null, Validators.required),
      'period_id': new FormControl(null, Validators.required),
      'school_location_id': new FormControl(null, Validators.required),
      'school_level_id': new FormControl(null, Validators.required),
      'role_id': new FormControl(null, Validators.required),
      'user_id': new FormControl(null, Validators.required),
      'year_level_id': new FormControl(null, Validators.required),
      'module_name': new FormControl(null, Validators.required),
      'approver_setup_id': new FormControl(null, Validators.required),
    });

    this.editForm = new FormGroup({
      'approver_setup_setting_id': new FormControl(null, Validators.required),
      'role_id': new FormControl(null, Validators.required),
      'user_id': new FormControl(null, Validators.required),
    });

    this.getSetupList();
  }

  onChangeAcademicYear(item: any, option: any = null) {
    if (option === 'add') {
      this.newForm.controls['academic_year'].markAsTouched();
      this.newForm.controls['academic_year'].setValue(item ? item.academic_year : null);
  
      this.newForm.controls['school_location_id'].setValue(null);
      return;
    }

    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);
  }

  onChangePeriod(item: any, option: any = null) {
    if (option === 'add') {
      this.newForm.controls['period_id'].markAsTouched();
      this.newForm.controls['period_id'].setValue(item ? item.period_id : null);

      return;
    }

    this.paramForm.controls['period_id'].markAsTouched();
    this.paramForm.controls['period_id'].setValue(item ? item.period_id : null);

    this.getApproverSetting();
  }

    
  getPeriodList() {
    this.registService.getPeriodList().subscribe({
      next: (response: any) => {
        if (response.status) {
          this.periodList = response.data;
        } else {
          Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: 'Error',
          text: 'An unexpected error occurred. Please check your connection and try again.',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
      }
    });
  }

  onChangeSchoolLevel(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['school_location_id'].markAsTouched();
      this.newForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);
  
      this.newForm.controls['school_level_id'].markAsTouched();
      this.newForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

      this.newForm.controls['year_level_id'].setValue(null);

      this.yearLevelRelations = [];
      if (item) {
        this.getNewPathwayMapping(option);
      }
      return;
    }

    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['year_level_id'].setValue(null);

    if (item) {
      this.getApproverSetting();
      this.getNewPathwayMapping(option);
    }
  }

   getNewPathwayMapping(option: any = null) {

    let params = {};
    if (option === 'add') {
      params = {
        academic_year: this.newForm.controls['academic_year'].value,
        school_location_id: this.newForm.controls['school_location_id'].value,
        school_level_id: this.newForm.controls['school_level_id'].value,
      }
    } else {
      params = {
        academic_year: this.paramForm.controls['academic_year'].value,
        school_location_id: this.paramForm.controls['school_location_id'].value,
        school_level_id: this.paramForm.controls['school_level_id'].value,
      }
    }
    this.pmService.yearLevelNoAcademic(params)
      .subscribe((response: PathwayMapping) => {
        // @ts-ignore
        if (response.status) {
          // @ts-ignore
          this.yearLevelRelations = response.data.slice();
          // this.yearLevelRelations.forEach((element: { selected: boolean; }) => {
          //   element.selected = false;
          // });
        } else {
          // @ts-ignore
        }
      }, (error: any) => {
      });
  }

  onChangeYearLevel(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['year_level_id'].markAsTouched();
      this.newForm.controls['year_level_id'].setValue(item ? +item.year_level_id : null);
  
      return;
    }

    this.paramForm.controls['year_level_id'].markAsTouched();
    this.paramForm.controls['year_level_id'].setValue(item ? +item.year_level_id : null);

    this.getApproverSetting();
  } 

  onChangeYearLevelByCheckbox(event: any, item: any) {
    if (event.checked) {
      this.yearLevelRelationsSelected.push(+item.year_level_id);
    } else {
      this.yearLevelRelationsSelected.splice(this.yearLevelRelationsSelected.indexOf(+item.year_level_id), 1);
    }
    this.insertYearLevel();
  }

  insertYearLevel() {
    this.newForm.controls['year_level_id'].markAsTouched();
    this.newForm.controls['year_level_id'].setValue(null);
    this.newForm.controls['year_level_id'].setValue(this.yearLevelRelationsSelected.length > 0 ? this.yearLevelRelationsSelected : null);
  }

  onChangeModule(item: any, option: any = null) {


    if (option === 'add') {
      this.newForm.controls['module_name'].markAsTouched();
      this.newForm.controls['module_name'].setValue(item ? item.module_name : null);

      this.newForm.controls['approver_setup_id'].markAsTouched();
      this.newForm.controls['approver_setup_id'].setValue(item ? item.approver_setup_id : null);
  
      return;
    }

    this.paramForm.controls['module_name'].markAsTouched();
    this.paramForm.controls['module_name'].setValue(item ? item.module_name : null);

    this.paramForm.controls['approver_setup_id'].markAsTouched();
    this.paramForm.controls['approver_setup_id'].setValue(item ? item.approver_setup_id : null);

    this.getApproverSetting();
  }

  getSetupList() {
    this.setupService.approverSetupList({}).subscribe((response: any) => {
      if (response.status) {
        this.setupList = response.data;
      } else {

        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  getRoleList() {
    this.roleList = [];
    this.spService.getRoleList().subscribe((response: any) => {
      if (response.status) {
        this.roleList = response.data;
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  getUserList() {
    this.userList = [];
    this.spService.getUserList({
      school_location_id: this.newForm.controls['school_location_id'].value,
      school_level_id: this.newForm.controls['school_level_id'].value,
      year_level_id: this.newForm.controls['year_level_id'].value,
      role_id: this.newForm.controls['role_id'].value,
    }).subscribe((response: any) => {
      if (response.status) {
        this.userList = response.data;
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  getUserListEdit() {
    this.userList = [];
    this.spService.getUserList({
      school_location_id: this.detailData.school_location_id,
      school_level_id: this.detailData.school_level_id,
      year_level_id: this.detailData.year_level_id,
      role_id: this.editForm.controls['role_id'].value,
    }).subscribe((response: any) => {
      if (response.status) {
        this.userList = response.data;
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  onChangeRole(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['role_id'].markAsTouched();
      this.newForm.controls['role_id'].setValue(item ? item.role_id : null);
  
      this.newForm.controls['user_id'].setValue(null);
      this.getUserList();
      return;
    }

    if (option === 'edit') {
      this.editForm.controls['role_id'].markAsTouched();
      this.editForm.controls['role_id'].setValue(item ? item.role_id : null);
  
      this.editForm.controls['user_id'].setValue(null);

      this.getUserListEdit();
      return;
    }
  }

  onChangeUser(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['user_id'].markAsTouched();
      this.newForm.controls['user_id'].setValue(item ? item.user_id : null);
  
      return;
    }

    if (option === 'edit') {
      this.editForm.controls['user_id'].markAsTouched();
      this.editForm.controls['user_id'].setValue(item ? item.user_id : null);
  
      return;
    }

    this.newForm.controls['user_id'].markAsTouched();
    this.newForm.controls['user_id'].setValue(item ? item.user_id : null);
  }

  getApproverSetting() {
    this.loading= true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.data = [];
    const params = {
      academic_year: this.paramForm.get('academic_year')?.value,
      school_location_id: this.paramForm.get('school_location_id')?.value,
      school_level_id: this.paramForm.get('school_level_id')?.value,
      year_level_id: this.paramForm.get('year_level_id')?.value,
      module_name: this.paramForm.get('module_name')?.value,
      period_id: this.paramForm.get('period_id')?.value,
    }
    this.subscription = this.setupService.approverSetupSettingList(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.data = response.data;
          this.loading = false;
        } else {
          Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
          });
          this.loading = false;
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: 'Error',
          text: 'An unexpected error occurred. Please check your connection and try again.',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
        this.loading = false;
      }
    });
  }

  openModalAdd (id: any = null) {
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalAddSetup, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      backdrop : 'static',
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  openModalEdit (id: any = null) {
    this.userList = [];
    if (id) {
      this.getSetupDetail(id);
    }
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalEditSetup, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      backdrop : 'static',
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  getSetupDetail(id: number) {
    this.setupService.approverSetupSettingList({approver_setup_setting_id: +id}).subscribe((response: any) => {
      if (response.status) {
        this.detailData = response.data[0];
        this.getUserListEdit();
        this.getRoleList();
        this.editForm.patchValue({
          approver_setup_setting_id: +this.detailData.approver_setup_setting_id,
          role_id: +this.detailData.role_id,
          user_id: this.detailData.user_id,
        });
        this.showEditModal = true;
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  onCloseModal() {
    this.modalService.dismissAll();
    this.newForm.reset();
    this.editForm.reset();
    this.detailData = null;
    this.userList = [];
    this.yearLevelRelationsSelected = [];
    this.showEditModal = false;
  }

  onAdd() {
    if (this.apiRun) {
      this.apiRun.unsubscribe();
    }
    this.apiRun = this.setupService.approverSetupSettingCreate(this.newForm.value).subscribe({
      next: (response: any) => {
        if(response.status){
          Swal.fire({
            title: "Success",
            text: "Approver setup has been created.",
            icon: "success"
          });
          this.onCloseModal();
          this.getApproverSetting();
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error"
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: "Error",
          text: "An unexpected error occurred. Please check your connection and try again.",
          icon: "error",
          confirmButtonText: "Retry"
        });
      }
    });
  }

  onEdit() {
    this.setupService.approverSetupSettingUpdate(this.editForm.value).subscribe({
      next: (response: any) => {
        if(response.status){
          Swal.fire({
            title: "Success",
            text: "Approver setup has been updated.",
            icon: "success"
          });
          this.onCloseModal();
          this.getApproverSetting();
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error"
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: "Error",
          text: "An unexpected error occurred. Please check your connection and try again.",
          icon: "error",
          confirmButtonText: "Retry"
        });
      }
    });
  }

  onDelete(period_setup_setting_id: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.setupService.approverSetupSettingDelete(period_setup_setting_id).subscribe({
          next: (response: any) => {
            if(response.status){
              Swal.fire({
                title: "Success",
                text: "Approver setup has been deleted.",
                icon: "success"
              });
              this.getApproverSetting();
            } else {
              Swal.fire({
                title: "Error",
                text: response.message,
                icon: "error"
              });
            }
          },
          error: (error: any) => {
            Swal.fire({
              title: "Error",
              text: "An unexpected error occurred. Please check your connection and try again.",
              icon: "error",
              confirmButtonText: "Retry"
            });
          }
        });
      }
    });
  }

}
